import tablePage from './tablePage.vue'
import headerTitle from './headerTitle.vue'

export default function registerCpns(app){
  app.component('tablePage',tablePage);
  app.component('headerTitle',headerTitle);
}
